<template>
	<v-form>
      	<v-container fluid v-if="this.hotels.length">
			<v-row >
				<v-col>
					<p class="display-1">
						P&L за 12 месяцев
					</p>
				</v-col>
			</v-row>
        	<v-row >
          		<v-col class="py-0" cols="12" sm="6" >
					<a-hotel-select v-model="hotelCode"
							  	 :hotels="hotels"
							  	 @change="changeHotel"
								 solo>
					</a-hotel-select>
				</v-col>
          		<v-col class="py-0" cols="12" sm="6" >
					<deptselect v-model="dept"
								ref="deptSelect"
								label="Отдел"
								:allowSummary="type == 1"
								@change="changeDept"
								solo>
					</deptselect>
				</v-col>
        	</v-row>
        	<v-row >
				<v-col class="pt-0" sm="12" md="6" >
					<v-subheader>Первый месяц</v-subheader>
					<v-date-picker
						v-model="monthStart"
						type="month"
						:landscape="$vuetify.breakpoint.smAndUp"
						:reactive="true"
						locale="ru-ru"
						required
						:show-current="false"
						:max="maxMonth"
						:min="minMonth"
						full-width
					></v-date-picker>
				</v-col>
				<v-col class="pt-0" sm="12" md="6" >
					<v-subheader>Последний месяц</v-subheader>
					<v-date-picker
						v-model="monthEnd"
						type="month"
						:landscape="$vuetify.breakpoint.smAndUp"
						:reactive="true"
						locale="ru-ru"
						required
						:show-current="false"
						:max="maxMonth"
						:min="minMonth"
						full-width
					></v-date-picker>
				</v-col>
        	</v-row>
        	<v-row >
				<v-col class="py-0" >
					<v-radio-group v-model="type"
					 			   :row="$vuetify.breakpoint.smAndUp"
								   @click="changeType">
						<template v-slot:label>
		        			<div style="width: 100px">Тип отчета</div>
		      			</template>
						<v-radio label="Финансовые результаты" value="1"></v-radio>
						<v-radio label="Метрики" value="2"></v-radio>
					</v-radio-group>
					<v-radio-group v-model="lan" :row="$vuetify.breakpoint.smAndUp">
						<template v-slot:label>
		        			<div style="width: 100px">Язык</div>
		      			</template>
						<v-radio label="Русский" value="ru"></v-radio>
						<v-radio label="Английский" value="en"></v-radio>
					</v-radio-group>

					<v-checkbox v-model="showForecast"
								v-if="allowShowForecast"
								:disabled="dept != 10"
								@change="changeShowForecast">
						<template v-slot:label>
							<v-tooltip :value="dept != 10" right>
								<template v-slot:activator="{ on }">
									<span>Показывать прогноз, если доступен</span>
									<span v-on="on"></span>
								</template>
								<span>Только для главной страницы P&L</span>
							</v-tooltip>
						</template>
					</v-checkbox>

					<v-checkbox v-model="unit"
								:disabled="type=='2'"
								label="В тысячах">
					</v-checkbox>
					<v-checkbox v-model="showNullLines"
								label="Показывать нулевые строки">
					</v-checkbox>
					<v-checkbox v-model="showPercent"
								label="Показывать % для каждого месяца">
					</v-checkbox>
					<v-checkbox v-if="allowShowInitialData"
								v-model="showInitialData"
								label="Показывать неутвержденные данные">
					</v-checkbox>
				</v-col>
        	</v-row>
			<v-row>
				<v-col class="pl-1" cols="12" >
			        <v-btn class="ma-2" color="primary" @click="combine('pdf')">Сформировать PDF</v-btn>
			        <v-btn class="ma-2" color="primary" @click="combine('xls')">Сформировать XLS</v-btn>
				</v-col>
			</v-row>
    	</v-container>
		<v-container fluid v-else>
			<v-row >
				<v-col>
					<p class="subtitle-1">
						Нет доступных отчетов
					</p>
				</v-col>
			</v-row>
		</v-container>
	</v-form>
</template>

<script>
	import aHotelSelect from '../../base/AHotelSelect.vue'
	import deptselect from './PlDeptSelect.vue'
	import {api} from '../../../lib/api'
	import {display} from '../../../lib/display'

	export default {
		components: {
			aHotelSelect,
			deptselect
		},
		data: () => ({
			hotelCode: '',
			hotels: null,
			dept: 10,
			monthEnd: "",
			year: '',
			type: '1',
			unit: true,
			showForecast: true,
			showNullLines: false,
			showPercent: false,
			showInitialData: false,
			lan: 'ru'
		}),
		computed: {
			allowShowForecast() {
				return this.$store.getters.userHasRight('pl_data_view_all')
			},
			selected() {
				return this.hotels.map(hotel => (hotel.code || null)).indexOf(this.hotelCode)
			},
			allowShowInitialData() {
				return this.$store.getters.userHasRight('pl_input')
			},
			maxMonth() {
				if (this.showInitialData) return undefined
				else if (this.selected == -1) return undefined
				else if (this.hotels[this.selected].maxMonth) {
					var D = new Date(this.hotels[this.selected].maxMonth)
					D.setMonth(D.getMonth() + 11)
					return D.toISOString().substr(0, 7)
				}
				else return undefined
			},
			minMonth() {
				if (this.showInitialData) return undefined
				else if (this.selected == -1) return undefined
				else if (this.hotels[this.selected].minMonth) {
					var D = new Date(this.hotels[this.selected].minMonth)
					D.setMonth(D.getMonth() - 11)
					return D.toISOString().substr(0, 7)
				}
				else return undefined
			},
			monthStart: {
				get: function () {
					if (!this.monthEnd) return ''
					var D = new Date(this.monthEnd)
					D.setUTCMonth(D.getUTCMonth() - 11)
					return D.toISOString().substr(0, 7)
				},
				set: function (newValue) {
					var D = new Date(newValue)
					D.setUTCMonth(D.getUTCMonth() + 11)
					this.monthEnd = D.toISOString().substr(0, 7)
				}
			},
		},
		created() {
			this.lan = this.$store.getters.prefLan

			if (this.$store.getters.userHo) {
				this.hotels = this.$store.getters.allHotels
			}
			else {
				this.hotels = this.$store.getters.userHotels
			}

			api.post('pl/get_available_report_months', { hotels: this.hotels })
			.then(response => {

				this.hotels = response.data.hotels
				if (this.hotels.length) {

					let selHotelCode = this.$store.getters.selectedHotelCode

					if (selHotelCode && this.hotels.find(el => el.code == selHotelCode)) {
						this.hotelCode = selHotelCode
					}
					else {
						this.hotelCode = this.hotels[0].code
						this.$store.dispatch('setSelectedHotelCode', this.hotelCode)
					}

					this.changeHotel()
				}
			}, error => {})
		},
		mounted() {
			if (this.allowShowForecast) {
				this.dept = 10
				this.showForecast = true
			}
			else {
				this.dept = this.$refs.deptSelect.filteredDepts[0].code
				this.showForecast = false
			}
		},
		methods: {
			changeHotel() {
				var D = new Date(this.hotels[this.selected].maxMonth)
				D.setMonth(11)
				this.monthEnd = D.toISOString().substr(0, 7)
			},
			changeType() {
				this.unit = this.type == 2 ? false : true

				if (this.dept == 10 && this.type == 2) this.dept = 0
			},
			changeDept() {
				if (this.dept != 10) this.showForecast = false
			},
			changeShowForecast() {
				if (this.showForecast) this.dept = 10
			},
			combine(format) {
				display.open({
					reportCode: 'pl_year',
					userId: this.$store.getters.userId,
					hotelCode: this.hotelCode,
					dept: this.dept,
					month: this.monthEnd,
					format: format,
					type: this.type,
					unit: this.unit ? 1000 : 1,
					showForecast: this.showForecast,
					showNullLines: this.showNullLines,
					showInitialData: this.showInitialData,
					showPercent: this.showPercent,
					lan: this.lan
				})
			}
		}
	}
</script>
